export default "__VITE_ASSET__sOKcfH6R__"